import { api, ApiRequestConfig } from 'api';
import { Bestseller, FetchConfiguratorsParams, RatingData, TSLPData } from './types';

export const fetchConfigurators = (
	url: string,
	params: FetchConfiguratorsParams,
	config?: ApiRequestConfig
): Promise<TSLPData> => api.get(url, params, config);

type FetchRatingParams = {
	regionCode: string;
	configuratorIds: number[];
};

export const fetchRating = (
	url: string,
	params: FetchRatingParams,
	config?: ApiRequestConfig
): Promise<RatingData[]> => api.post(url, params, config);

export const fetchConfiguratorSiblingsData = (
	url: string,
	params: { regionCode: string },
	config?: ApiRequestConfig
): Promise<Bestseller[]> => api.get(url, params, config);

export const fetchBestSellersData = (
	url: string,
	params: { regionCode: string },
	config?: ApiRequestConfig
): Promise<Bestseller[]> => api.get(url, params, config);
